import type { FormConfig } from '#types/config/components/form'
import type { RecursivePartial } from '#types/utils'

export default {
  cancelButtonVariant: 'tertiary'
} satisfies RecursivePartial<FormConfig['addAddress']>
